import * as React from 'react';
type IconRegulatorioEUProps = React.SVGProps<SVGSVGElement>;

export const IconRegulatorioEU: React.FC<IconRegulatorioEUProps> = (props) => (
	<svg
		width={66}
		height={66}
		viewBox="0 0 66 66"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<circle
			cx="33"
			cy="33"
			r="32.6875"
			fill="#FFA692"
		/>
		<circle
			cx="33"
			cy="33"
			r="26.8504"
			fill="#EBF8F0"
		/>
		<path
			d="M24.382 48.114C23.5897 48.114 22.8823 47.8782 22.2597 47.4067C21.6372 46.9074 21.3259 46.2972 21.3259 45.5761V21.5289C21.3259 20.8078 21.5664 20.2115 22.0475 19.74C22.5568 19.2407 23.1794 18.9911 23.9151 18.9911H36.1397C37.6112 18.9911 38.9836 19.3794 40.257 20.156C41.5587 20.9049 42.6057 21.9588 43.3981 23.3179C44.1904 24.6492 44.5866 26.1886 44.5866 27.936C44.5866 28.9899 44.3602 30.0162 43.9074 31.0147C43.483 32.0132 42.8887 32.9146 42.1247 33.7189C41.3889 34.5233 40.5542 35.1473 39.6203 35.5911L39.6628 34.6342C40.4551 35.0503 41.106 35.5495 41.6153 36.132C42.153 36.6867 42.5633 37.2969 42.8463 37.9626C43.1576 38.6005 43.3415 39.2939 43.3981 40.0428C43.5113 40.7362 43.582 41.3464 43.6103 41.8733C43.6669 42.4003 43.7518 42.8441 43.865 43.2047C44.0065 43.5652 44.2612 43.8426 44.629 44.0368C45.2516 44.3973 45.6336 44.9243 45.7751 45.6177C45.9449 46.2834 45.7892 46.8797 45.3082 47.4067C44.9969 47.7673 44.6007 48.003 44.1197 48.114C43.6386 48.1972 43.1575 48.1972 42.6765 48.114C42.1954 48.003 41.7993 47.8643 41.488 47.6979C41.0069 47.4206 40.5259 47.0184 40.0448 46.4914C39.5637 45.9367 39.1676 45.2017 38.8563 44.2864C38.5733 43.3711 38.4318 42.1923 38.4318 40.75C38.4318 40.2785 38.3469 39.8486 38.1772 39.4603C38.0074 39.0443 37.7668 38.6976 37.4556 38.4202C37.1443 38.1151 36.7481 37.8932 36.2671 37.7545C35.786 37.5881 35.2201 37.5049 34.5692 37.5049H25.995L26.6317 36.548V45.5761C26.6317 46.2972 26.4336 46.9074 26.0375 47.4067C25.6413 47.8782 25.0895 48.114 24.382 48.114ZM26.0375 33.2197H35.9275C36.4369 33.2197 36.9321 32.9978 37.4131 32.554C37.8942 32.0825 38.2903 31.4584 38.6016 30.6818C38.9129 29.8775 39.0685 29.0038 39.0685 28.0608C39.0685 26.8404 38.729 25.828 38.0498 25.0237C37.399 24.1916 36.6915 23.7756 35.9275 23.7756H26.1224L26.6317 22.4442V34.2182L26.0375 33.2197Z"
			fill="#7EAE90"
		/>
	</svg>
);

export default IconRegulatorioEU;
